import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const LightbulbIconOn = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            version="1.1"
            x="0px"
            y="0px"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            enableBackground="new 0 0 24 24"
            xmlSpace="preserve"
            aria-hidden="true"
            stroke="currentColor"
            fill="none"
            strokeWidth="1.5"
        >
            <g id="lightbulb-on--lighting-light-shine-incandescent-bulb-lights">
                <path strokeLinecap="round" strokeLinejoin="round" d="M20.15625 11.25h1.40625" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M0.9375 11.25h1.40625" />
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.9522031250000005 4.952296875 3.957825 3.9579375"
                />
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m17.547796875 4.952296875 0.994359375 -0.994359375"
                />
                <path
                    id="Union"
                    strokeLinejoin="round"
                    d="M7.345171875 16.52484375C5.732625 15.329156249999999 4.6875 13.411640625 4.6875 11.25c0 -3.624375 2.938125 -6.5625 6.5625 -6.5625s6.5625 2.938125 6.5625 6.5625c0 2.161640625 -1.045125 4.07915625 -2.6576718749999997 5.2748437500000005 -0.06684375000000001 0.381140625 -0.13298437500000002 0.7421249999999999 -0.190359375 1.04859375 -0.1048125 0.56015625 -0.543515625 0.9921562500000001 -1.110328125 1.0512187499999999C13.251328125 18.68746875 12.369984375 18.75 11.25 18.75c-1.119984375 0 -2.001328125 -0.06253125 -2.6041406250000003 -0.12534375 -0.5668125 -0.059062500000000004 -1.005515625 -0.49106250000000007 -1.110328125 -1.0512187499999999 -0.057374999999999995 -0.30646875 -0.123515625 -0.667453125 -0.190359375 -1.04859375Z"
                />
                <path
                    id="Subtract"
                    strokeLinejoin="round"
                    d="M8.342765624999998 18.55396875c0.070921875 0.561515625 0.147328125 1.110234375 0.21346875 1.56609375 0.1025625 0.7072968749999999 0.6110156250000001 1.283296875 1.3209375 1.365703125 0.3763125 0.043687500000000004 0.83775 0.07673437500000001 1.3729687499999998 0.07673437500000001 0.51740625 0 0.9847031249999999 -0.030890625 1.37925 -0.07237500000000001 0.79471875 -0.08367187499999999 1.358578125 -0.750140625 1.4271093750000001 -1.5463125 0.036187500000000004 -0.420421875 0.0789375 -0.904875 0.12459374999999999 -1.3988906250000002 -0.1025625 0.0405 -0.21206250000000001 0.067734375 -0.3268125 0.07968750000000001 -0.6028125 0.062859375 -1.4841562499999998 0.125390625 -2.6041406250000003 0.125390625 -1.119984375 0 -2.001375 -0.06253125 -2.6041406250000003 -0.125390625 -0.10603125000000001 -0.011015625 -0.2075625 -0.035109375 -0.303234375 -0.070640625Z"
                />
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 11.25c0 -2.071078125 -1.6789218750000001 -3.75 -3.75 -3.75"
                />
                <path strokeLinecap="round" strokeLinejoin="round" d="m11.25 0.9375 0 1.40625" />
            </g>
        </svg>
    </IconWrapper>
)
